export default "__VITE_ASSET__d15a1109__"